import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    borderRadius: "19px",
    backgroundColor: "red",
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
    paddingLeft: 0,
  },
  cover: {
    flex: 0.5,
  },
}));

export default function MediaControlCard(props) {
  const classes = useStyles();

  return (
    <Card style={props.crdStyle}>
      <CardMedia
        className={classes.cover}
        image={props.image}
        title="Live from space album cover"
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography
            color={"#000"}
            variant="h6"
            style={{
              margin: "5px 0px 5px 0",
              fontSize: 18,
              fontWeight: 400,
            }}
          >
            {props.title}
          </Typography>
          <Typography
            color={"#1a468d"}
            variant="h5"
            style={{
              margin: "5px 0px 5px 0",
              fontSize: 26,
              fontWeight: 700,
            }}
          >
            {props.children}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
}
